var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_763_2",
    "data-name": "Component 763 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16425",
    "data-name": "Rectangle 16425",
    width: 25,
    height: 25,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65903",
    "data-name": "Group 65903",
    transform: "translate(15001.252 -7982.748)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5264",
    "data-name": "Ellipse 5264",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(-14999.252 7984.748)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5266",
    "data-name": "Ellipse 5266",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(-14999.252 7998.748)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5265",
    "data-name": "Ellipse 5265",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(-14985.252 7984.748)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5267",
    "data-name": "Ellipse 5267",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(-14985.252 7998.748)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3083",
    "data-name": "Line 3083",
    x2: 14.024,
    transform: "translate(-14995.225 7988.236)",
    fill: "none",
    stroke: "#0f2532",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3084",
    "data-name": "Line 3084",
    x2: 14.024,
    transform: "translate(-14995.225 8002.26)",
    fill: "none",
    stroke: "#0f2532",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3085",
    "data-name": "Line 3085",
    y1: 13.484,
    transform: "translate(-14995.764 7988.775)",
    fill: "none",
    stroke: "#0f2532",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3086",
    "data-name": "Line 3086",
    y1: 13.484,
    transform: "translate(-14981.74 7988.775)",
    fill: "none",
    stroke: "#0f2532",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygonIcon.377bae0dd5957a4c610f94f3fb014ae8.svg";
export { ForwardRef as ReactComponent };